import { useCallback, useEffect } from 'react';
const isMac = () => {
    if (typeof navigator !== 'undefined') {
        return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    }
    return false;
};
export const useSpotlightShortcut = ({ onOpen, onClose, isOpen = false, enabled = true, }) => {
    const handleKeyDown = useCallback((event) => {
        if (!enabled)
            return;
        const isModifierPressed = isMac() ? event.metaKey : event.ctrlKey;
        if (isModifierPressed && event.key.toLowerCase() === 'k') {
            event.preventDefault();
            event.stopPropagation();
            if (!isOpen) {
                onOpen();
            }
        }
        if (event.key === 'Escape' && isOpen && onClose) {
            event.preventDefault();
            event.stopPropagation();
            onClose();
        }
    }, [enabled, isOpen, onOpen, onClose]);
    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown, true);
        return () => {
            document.removeEventListener('keydown', handleKeyDown, true);
        };
    }, [handleKeyDown]);
};
export const getSpotlightShortcutText = () => {
    return isMac() ? '⌘K' : 'Ctrl+K';
};
//# sourceMappingURL=use-spotlight-shortcut.js.map